import React from 'react';
import ReactDOM from 'react-dom';
import WebFont from 'webfontloader';
import '../node_modules/slick-carousel/slick/slick.scss';
import '../node_modules/slick-carousel/slick/slick-theme.scss';
import './styles/styles.scss';
import AppRouter from './routers/AppRouter';

import registerServiceWorker from './registerServiceWorker';

WebFont.load({
  fontinactive(family) {
    if (family === 'Bitter' && 'Work Sans') {
      WebFont.load({
        custom: {
          families: ['Bitter', 'Work Sans'],
          urls: ['/styles/base/local-fonts.css'],
        },
      });
    }
  },
  google: {
    families: ['Work Sans:400,500,600,700', 'Bitter:400,400i,700', 'sans-serif', 'serif'],
  },
});

if (typeof window !== 'undefined') {
  ReactDOM.render(<AppRouter />, document.getElementById('root'));
}
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js